import { render, staticRenderFns } from "./LabResultForm.vue?vue&type=template&id=9840a0d8&"
import script from "./LabResultForm.vue?vue&type=script&lang=js&"
export * from "./LabResultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports